import { CtaButton } from '@tkww/orion-web-ds-action';
import { TextBody, TextEditorial } from '@tkww/orion-web-ds-text';
import React, { memo, useRef, type FC } from 'react';
import Styles from './styles.scss';

interface ReviewPromptBoxProps {
	title: string;
	message: string;
	handleClick: () => void;
}

export const ReviewPromptBox: FC<ReviewPromptBoxProps> = memo(
	({ title, message, handleClick }) => {
		const ref = useRef(null);

		return (
			<div className={Styles.reviewPromptBox} ref={ref}>
				<TextEditorial bold>{title}</TextEditorial>
				<TextBody size="md">{message}</TextBody>
				<CtaButton styleType="secondary" size="md" onClick={handleClick}>
					Write a review
				</CtaButton>
			</div>
		);
	},
);
